import React from "react";
import { useNavigate } from "react-router-dom";
import "./MainServices.css";

const categories = [
  {
    title: "Residential Construction",
    slug: "residential",
    icon: "🏡",
    desc: "Premium villas, apartments & full renovation projects tailored to your lifestyle.",
    subItems: ["Villa Construction", "Apartment Construction", "Renovation & Remodeling"],
  },
  {
    title: "Commercial Construction",
    slug: "commercial",
    icon: "🏢",
    desc: "Corporate offices, retail spaces & robust industrial structures built to last.",
    subItems: ["Office Buildings", "Retail Spaces", "Industrial Structures"],
  },
  {
    title: "Interior Design",
    slug: "interior",
    icon: "🛋️",
    desc: "Modern interiors with optimized space planning and premium finishing.",
    subItems: ["Home Interior", "Office Interior", "Space Planning"],
  },
  {
    title: "Designs",
    slug: "designs",
    icon: "📐",
    desc: "Precision floor plans, 2D layouts & stunning 3D elevations for every project.",
    subItems: ["Floor Plan", "2D Layout", "3D Elevation"],
  },
];

const MainServices = () => {
  const navigate = useNavigate();

  return (
    <div className="main-services-page">
      <div className="ms-hero">
        <p className="ms-tag">DESIGN PLANNING</p>
        <h1>Choose Your Service</h1>
        <p className="ms-sub">Select a category to explore our specialized construction and design services.</p>
      </div>

      <div className="ms-grid">
        {categories.map((cat) => (
          <div
            key={cat.slug}
            className="ms-card"
            onClick={() => navigate(`/services/design/${cat.slug}`)}
          >
            <div className="ms-card-icon">{cat.icon}</div>
            <h2>{cat.title}</h2>
            <p>{cat.desc}</p>
            <ul className="ms-sub-list">
              {cat.subItems.map((item, i) => (
                <li key={i}>▸ {item}</li>
              ))}
            </ul>
            <span className="ms-cta">View Services →</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MainServices;